import type { AccordionSlots } from '@mui/material';
import AccordionSummary from '@mui/material/AccordionSummary';
import Fade from '@mui/material/Fade';
import { accordionClasses } from '@mui/material/Accordion';
import { accordionDetailsClasses } from '@mui/material/AccordionDetails';
import { styled } from '@mui/material/styles';
import SummaryTitleWithTooltip from './SummaryTitleWithTooltip.tsx';
import { AccordionDetails } from './AccordionDetails.tsx';
import { AccordionStyled } from '../SidePanel/component/SidePanelAccordion';

const AccordionStyledComponent = styled(AccordionStyled)(() => ({
  '&::before, &::after': {
    display: 'none',
  },
}));

const AccordionSummeryStyled = styled(AccordionSummary)(() => ({
  display: 'flex',
  padding: 0,
  alignItems: 'center',
  gap: '0',
  minHeight: '36px',
  alignSelf: 'stretch',
  width: '100%',
  '& .MuiAccordionSummary-content': {
    margin: 0,
    width: '88%',
    '& > div': {
      width: '100%',
      alignItems: 'flex-end',
    },
  },
  '&.Mui-expanded': {
    minHeight: '24px',
    '& .MuiAccordionSummary-contentGutters': {
      margin: '0',
    },
  },
}));

const accordionOpened = {
  [`& .${accordionClasses.region}`]: {
    height: 'auto',
  },
  [`& .${accordionDetailsClasses.root}`]: {
    display: 'block',
  },
};
const accordionClosed = {
  [`& .${accordionClasses.region}`]: {
    height: 0,
  },
  [`& .${accordionDetailsClasses.root}`]: {
    display: 'none',
  },
};

export const VariablesAccordion = ({ options, isEditor, accordionIdentifier, group, children, updateAccordionState, accordionState }) => {
  const handleExpansion = () => {
    updateAccordionState(accordionIdentifier, !accordionState);
  };

  return (
    <AccordionStyledComponent
      expanded={accordionState}
      onChange={handleExpansion}
      slots={{ transition: Fade as AccordionSlots['transition'] }}
      slotProps={{ transition: { timeout: 400 } }}
      sx={[accordionState ? accordionOpened : accordionClosed]}
    >
      <AccordionSummeryStyled aria-controls="panel1-content" id="panel1-header">
        <SummaryTitleWithTooltip isRounded={!isEditor} expanded={accordionState} onActiveUpdate={() => null} group={group} />
      </AccordionSummeryStyled>
      {children?.map((child) => {
        const variableMeta = options.find((o) => o.path === `${group}/${child.key.slice(child.key.indexOf('[') + 1, -1)}`);

        if (!variableMeta) return null;

        return <AccordionDetails variableMeta={variableMeta} isEditor={isEditor} key={child.key} />;
      })}
    </AccordionStyledComponent>
  );
};

export default VariablesAccordion;
